import { render, staticRenderFns } from "./RealEstateIcon.vue?vue&type=template&id=0f48c6ce&"
import script from "./RealEstateIcon.vue?vue&type=script&lang=js&"
export * from "./RealEstateIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f48c6ce')) {
      api.createRecord('0f48c6ce', component.options)
    } else {
      api.reload('0f48c6ce', component.options)
    }
    module.hot.accept("./RealEstateIcon.vue?vue&type=template&id=0f48c6ce&", function () {
      api.rerender('0f48c6ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/realEstate/RealEstateIcon.vue"
export default component.exports